export default __webpack_public_path__ + "static/media/French_CA_Sample.4d5bd3cf.png";